var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SGPPageHeaderComponent',{attrs:{"titulo":"Painel Backlog","textoBusca":"","mostrarBusca":false,"mostrarBotaoFiltroAvancado":true},on:{"emitAbrirFiltro":_vm.abrirFiltro}})
}
var staticRenderFns = []

export { render, staticRenderFns }